export default __webpack_public_path__ + "static/media/Icon_Sort.01e1e2f7.svg";